import { mapGetters } from 'vuex'

export default {

    computed: {
        ...mapGetters('content', [
			'getContent',
			'getContentKey'
		]),
        symptoms() {
			return this.patientEventType('symptom')
		},
        symptomAnalysis() {
			// id -> { title, answer -> array of answers }
			var analysis = {}
            var missing = {}

            this.symptoms.forEach((symptom) => {
                let symptomId = symptom.type.split(':')[1]
                let content = this.getContent('symptom', symptomId)
                if (! content) {
                    missing[symptomId] = true
                    return
                }

                // Initialize the symptom analysis
                if (! analysis[symptomId]) {
                    analysis[symptomId] = {
                        title: content.title,
                        question: {}
                    }

                    content.question.forEach((question) => {
                        analysis[symptomId].question[question.id || question.title] = {
                            title: question.title,
                            answer: {}
                        }
                    })
                }

                if (Array.isArray(symptom.question)) {
                    symptom.question.forEach((answer) => {
                        let answerAnalysis = analysis[symptomId].question[answer.id || answer.title]

                        if (answerAnalysis) {
                            if (Array.isArray(answer.option))
                                answer.option.forEach((option) => {
                                    answerAnalysis[option] = (answerAnalysis[option] || 0) + 1
                                })
                            else if (answer.value)
                                answerAnalysis[answer.value] = (answerAnalysis[answer.value] || 0) + 1
                        }
                    })
                }
            })
            if(Object.keys(missing).length > 0)
                this.loadContent({
                    type: 'symptom',
                    id: Object.keys(missing)
                })

			return analysis
		}
    }
}
